<template></template>
<script type="plain/text">
import LoginResultType from "@/scripts/models/enums/loginResultType.enum";
import LoginService from "@/scripts/services/login.service";
import { Routes } from "@/scripts/models/enums/routes.enum.js";
import { LoginSocialMedia } from "@/scripts/models/enums/socialMedias.enum.js";
import UserService from "@/scripts/services/user.service";
import CommonHelper from "@/scripts/helpers/common.helper";
import CampaignService from "@/scripts/services/campaign.service";
import { createMsalInstance, getMsalInstance } from "../../../scripts/helpers/msal.helper";
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      userService: new UserService(),
      loginService: new LoginService(),
      campaignService: new CampaignService(),
      msalApp: null,
      campaign: null,
    };
  },
  async created() {
  if (window.__msal_handled__) return;
    window.__msal_handled__ = true;

  const clientId = this.campaignSSO?.clientId || sessionStorage.getItem('msal_clientId');
  const tenantId = this.campaignSSO?.tenantId || sessionStorage.getItem('msal_tenantId');
  if (!clientId || !tenantId) return;

  this.msalApp = await createMsalInstance(clientId, tenantId, "/");

  // Evita loops
  const result = await this.msalApp.handleRedirectPromise();
  if (!result) {
    console.log("Nenhum redirect para tratar.");
    return; // <--- IMPORTANTE
  }


  const { account, idToken, idTokenClaims } = result;
  sessionStorage.setItem("id_token", idToken);
  sessionStorage.setItem("user_email", idTokenClaims?.email ?? account?.username ?? "");
  sessionStorage.setItem("user_name", idTokenClaims?.name ?? "");

  // Apenas uma chamada
  await this.loginService
    .msalLogin(idToken)
    .then(this.onMsalLoginCheckCallback)
    .catch(this.onLoginErrorCallback);
  },
  computed: {
    ...mapGetters(["campaignSSO", "campaignLandingPageConfig"]),
  },
  methods: {
    ...mapActions([
      "setLogged",
      "setReloadCart",
      "setSocialMediaLogin",
      "setMissingInformation",
      "getCampaignSSO"
    ]),
    onMsalLoginCheckCallback(msalLoginResponse) {
      if (msalLoginResponse.signedIn == LoginResultType.Success) {
        this.$store.commit("REMOVE_ROLES");
        this.userService.listRolesOfLoggedUser().then(
          function (data) {
            this.$store.commit("SET_ROLES", data);
            this.setLogged(true);
            this.setReloadCart(true);

            if (this.campaignLandingPageConfig.campaign.modalConfirmationOnDonationActive) {
              this.$nextTick(() => {
                this.$store.commit("SHOW_PERSON_INFO");
              });
            }

            if (this.$router.currentRoute.name == Routes.web.Login) {
              this.$router.push({ name: Routes.app.CampaignLandingPage });
            } else {
              window.location = window.location.origin;
            }
          }.bind(this)
        );
      } else if (msalLoginResponse.signedIn == LoginResultType.MissingInfo) {
        const payload = {
          registerStep: 5,
          missingPersonInfo: msalLoginResponse.missingPersonInfo,
        };
        this.setMissingInformation(payload);
        window.location = window.location.origin;
      } else {
        const payload = {
          registerStep: 4,
          socialMediaUser: msalLoginResponse.profileData,
          socialMedia: LoginSocialMedia.Microsoft,
        };
        this.setSocialMediaLogin(payload);
        window.location = window.location.origin;
      }

      this.msalApp.getTokenCache().clear();
      sessionStorage.removeItem("id_token");
      sessionStorage.removeItem("user_email");
      sessionStorage.removeItem("user_name");
    },
    onLoginErrorCallback(err) {
      if (err && err.errorMessage) {
        //alert(err.errorMessage);
        CommonHelper.swal("", err.errorMessage, "error");
      }

      this.$router.push({ name: Routes.web.Login });
    },
  },
};
</script>
